export const keysAreEqual = (keyA?: string | number | null, keyB?: string | number | null, caseSensitive: boolean = false) => {
    if (caseSensitive) {
        return keyA?.toString() === keyB?.toString();
    }

    return keyA?.toString().toUpperCase() === keyB?.toString().toUpperCase();
}